import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Eyebrow, StatusBadge, PageLoader } from "@/components/shared";
import { CheckCircle2 } from "lucide-react";

export default function StatusPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/status").then((r) => setData(r.data)); }, []);
  if (!data) return <PageLoader />;

  const allGood = data.overall === "operational";
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
      <Eyebrow>Status</Eyebrow>
      <div className={`flex items-center gap-4 rounded-2xl border p-6 ${allGood ? "border-emerald-500/30 bg-emerald-500/5" : "border-amber-500/30 bg-amber-500/5"}`}>
        <CheckCircle2 className={`h-10 w-10 ${allGood ? "text-emerald-400" : "text-amber-400"}`} />
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-50">{allGood ? "All systems operational" : "Some systems degraded"}</h1>
          <p className="text-sm text-slate-400">Live status of the ZettaKeep control plane and regions.</p>
        </div>
      </div>

      <div className="mt-8 divide-y divide-slate-800 rounded-2xl border border-slate-800 bg-slate-900/40">
        {data.components.map((c) => (
          <div key={c.id} className="flex items-center justify-between px-5 py-4" data-testid={`status-component-${c.name}`}>
            <span className="text-slate-200">{c.name}</span>
            <StatusBadge status={c.status} />
          </div>
        ))}
      </div>

      <div className="mt-8">
        <h2 className="mb-3 font-display text-lg font-semibold text-slate-100">Incident history</h2>
        {data.incidents.length === 0 ? (
          <p className="rounded-xl border border-slate-800 bg-slate-900/40 p-5 text-sm text-slate-500">No incidents reported. All clear.</p>
        ) : data.incidents.map((i) => (
          <div key={i.id} className="mb-3 rounded-xl border border-slate-800 bg-slate-900/40 p-5">
            <div className="font-semibold text-slate-100">{i.title}</div>
            <p className="mt-1 text-sm text-slate-400">{i.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
